import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import ApplicationKeys from '@jira/platform__common-constants/src/application-keys.tsx';
import type {
	IssueAppConfiguration,
	ProjectConfig,
} from './ProjectContextServiceActions.types.tsx';

// Issue actions
const FLAG_ACTIONS = 'flagActions';

const CARD_COVER_ACTIONS = 'cardCoverActions';

const coreConfiguration: () => IssueAppConfiguration = () => ({
	applicationKey: ApplicationKeys.CORE_ISSUE,
	issueActions: [],
	ecosystemEnabled: true,
});

const softwareConfiguration: () => IssueAppConfiguration = () => ({
	applicationKey: ApplicationKeys.SOFTWARE_ISSUE,
	issueActions: [FLAG_ACTIONS],
	ecosystemEnabled: true,
});

const simpleSoftwareBoardConfiguration: () => IssueAppConfiguration = () => ({
	applicationKey: ApplicationKeys.SIMPLE_SOFTWARE_BOARD,
	issueActions: [FLAG_ACTIONS, CARD_COVER_ACTIONS],
	ecosystemEnabled: true,
});

const serviceDeskConfiguration: () => IssueAppConfiguration = () => ({
	applicationKey: ApplicationKeys.SERVICE_DESK,
	issueActions: [],
	ecosystemEnabled: true,
});

export const getIssueConfiguration = (config: ProjectConfig | null): IssueAppConfiguration => {
	if (config) {
		switch (config.projectType) {
			case SOFTWARE_PROJECT:
				if (config.isSimplified) {
					return simpleSoftwareBoardConfiguration();
				}
				return softwareConfiguration();
			case CORE_PROJECT:
				return coreConfiguration();
			case SERVICE_DESK_PROJECT:
				return serviceDeskConfiguration();
			default:
				// fallback to sofware config
				return softwareConfiguration();
		}
	}
	return softwareConfiguration();
};
